export const mdsGradients = () => ({
  brand: {
    normal: "linear-gradient(215.0deg, #EB2487 5%, #F93939 95%)",
  },
});
